import { useParams } from 'react-router-dom';
import { Alert } from '@/components/ui/Alert';
import { HealthStatusCard } from '@/components/HealthStatusCard';
import { BotStatusCard } from '@/components/BotStatusCard';
import { useAuth } from '@/lib/auth/useAuth';

/**
 * Real bot presence (via the Bridge, see dembot/docs/BOT_BRIDGE.md) now
 * exists — this page's messaging is updated to reflect that accurately
 * rather than the earlier, now-stale "ships in later phases" note. What's
 * genuinely still not connected: per-guild CONFIGURATION data (AutoMod
 * settings, moderation history, etc.) — that's the feature-by-feature
 * integration work that comes after this Bridge V1, not this batch.
 */
export function GuildOverviewPage() {
  const { guildId } = useParams<{ guildId: string }>();
  const { guilds } = useAuth();

  const guild = guilds.find((g) => g.id === guildId);

  return (
    <div className="space-y-6 max-w-3xl">
      <div>
        <h1 className="text-h1 text-text-primary mb-1">{guild?.name ?? 'Overview'}</h1>
        <p className="text-small text-text-tertiary">Server ID: {guildId}</p>
      </div>

      {guild ? (
        <Alert
          tone={guild.botPresent ? 'success' : guild.botPresent === false ? 'warning' : 'info'}
          title={
            guild.botPresent === true
              ? 'Dem is in this server'
              : guild.botPresent === false
                ? 'Dem is not in this server yet'
                : "Bot presence isn't known right now"
          }
          description={
            guild.botPresent === true
              ? 'Real-time via the Bot Bridge. Per-feature configuration (AutoMod, moderation history, etc.) is not connected yet — that lands feature-by-feature in upcoming work.'
              : guild.botPresent === false
                ? 'Invite Dem to this server to configure it from here.'
                : 'The Bot Bridge is not configured or not reachable right now — this is a real "unknown", not a guess.'
          }
        />
      ) : null}

      <BotStatusCard />
      <HealthStatusCard />
    </div>
  );
}
